import { render, staticRenderFns } from "./AprendisajeSostenible.vue?vue&type=template&id=474dcfce"
import script from "./AprendisajeSostenible.vue?vue&type=script&lang=js"
export * from "./AprendisajeSostenible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports